/* eslint-disable import/prefer-default-export */
import { newRelicJSError } from '@nmx/utils/dist/utilities/frontend/Analytics/new_relic_helper';

// this function requires this: <script async src="https://www.googletagmanager.com/gtag/js?id={{@root.googleFloodlightsId}}"></script>
// Event snippet for Pre-Client: Lead Form Submission conversion page
export function floodlightsTrackLead(sendTo, googleFloodlightsId = '<%=googleFloodlightsId%>') {
  try {
    if (sendTo) {
      window.gtag('event', 'conversion', {
        allow_custom_scripts: true,
        send_to: `${googleFloodlightsId}/${sendTo}`,
      });
    }
  } catch (err) {
    const error = `Error tracking lead form submission for Floodlight Pixel: ${err}`;
    newRelicJSError(error);
    console.error(error);
  }
}
